module.exports = __webpack_public_path__ + "img/STERiGLIDE_03.e2a4549f.jpg";